import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Post Info'
export const group = 'Dynamic blog'
export const beta = false

export const defaultOptions = {
  content: {
    data: {
      post: '',
      type: 'featured-post-info-mod'
    }
  }
}

export const icon = ''

export default class ElBogFeaturedPostInfo extends SectionProvider {
  constructor (options = {}) {
    super('ElFeaturedPostInfo', options)

    this.name = name
    this.group = group
    this.defaultOptions = defaultOptions
  }
}
